import config from '../../config';

const { fontAppUrl } = config;

export interface FontFamily {
  id: string;
  name: string;
  default: string;
  fonts: Font[];
}

export interface Font {
  name: string;
  url: string;
}

export const fontFamilies: FontFamily[] = [
  {
    id: 'abril-fatface',
    name: 'Abril Fatface',
    default: 'Regular',
    fonts: [
      {
        name: 'Regular',
        url: `${fontAppUrl}/AbrilFatface-Regular.woff`,
      },
    ],
  },
  {
    id: 'alice',
    name: 'Alice',
    default: 'Regular',
    fonts: [
      {
        name: 'Regular',
        url: `${fontAppUrl}/Alice-Regular.woff`,
      },
    ],
  },
  {
    id: 'arimo',
    name: 'Arimo',
    default: 'Regular',
    fonts: [
      {
        name: 'Regular',
        url: `${fontAppUrl}/Arimo-Regular.woff`,
      },
      {
        name: 'Medium',
        url: `${fontAppUrl}/Arimo-Medium.woff`,
      },
      {
        name: 'Semi Bold',
        url: `${fontAppUrl}/Arimo-SemiBold.woff`,
      },
      {
        name: 'Bold',
        url: `${fontAppUrl}/Arimo-Bold.woff`,
      },
      {
        name: 'Italic',
        url: `${fontAppUrl}/Arimo-Italic.woff`,
      },
      {
        name: 'Medium Italic',
        url: `${fontAppUrl}/Arimo-MediumItalic.woff`,
      },
      {
        name: 'Semi Bold Italic',
        url: `${fontAppUrl}/Arimo-SemiBoldItalic.woff`,
      },
      {
        name: 'Bold Italic',
        url: `${fontAppUrl}/Arimo-BoldItalic.woff`,
      },
    ],
  },
  {
    id: 'cabin',
    name: 'Cabin',
    default: 'Regular',
    fonts: [
      {
        name: 'Regular',
        url: `${fontAppUrl}/Cabin-Regular.woff`,
      },
      {
        name: 'Medium',
        url: `${fontAppUrl}/Cabin-Medium.woff`,
      },
      {
        name: 'Semi Bold',
        url: `${fontAppUrl}/Cabin-SemiBold.woff`,
      },
      {
        name: 'Bold',
        url: `${fontAppUrl}/Cabin-Bold.woff`,
      },
      {
        name: 'Italic',
        url: `${fontAppUrl}/Cabin-Italic.woff`,
      },
      {
        name: 'Medium Italic',
        url: `${fontAppUrl}/Cabin-MediumItalic.woff`,
      },
      {
        name: 'Semi Bold Italic',
        url: `${fontAppUrl}/Cabin-SemiBoldItalic.woff`,
      },
      {
        name: 'Bold Italic',
        url: `${fontAppUrl}/Cabin-BoldItalic.woff`,
      },
    ],
  },
  {
    id: 'kanit',
    name: 'Kanit',
    default: 'Regular',
    fonts: [
      {
        name: 'Thin',
        url: `${fontAppUrl}/Kanit-Thin.woff`,
      },
      {
        name: 'Extra Light',
        url: `${fontAppUrl}/Kanit-ExtraLight.woff`,
      },
      {
        name: 'Light',
        url: `${fontAppUrl}/Kanit-Light.woff`,
      },
      {
        name: 'Regular',
        url: `${fontAppUrl}/Kanit-Regular.woff`,
      },
      {
        name: 'Medium',
        url: `${fontAppUrl}/Kanit-Medium.woff`,
      },
      {
        name: 'Semi Bold',
        url: `${fontAppUrl}/Kanit-SemiBold.woff`,
      },
      {
        name: 'Bold',
        url: `${fontAppUrl}/Kanit-Bold.woff`,
      },
      {
        name: 'Extra Bold',
        url: `${fontAppUrl}/Kanit-ExtraBold.woff`,
      },
      {
        name: 'Black',
        url: `${fontAppUrl}/Kanit-Black.woff`,
      },
      {
        name: 'Thin Italic',
        url: `${fontAppUrl}/Kanit-ThinItalic.woff`,
      },
      {
        name: 'Extra Light Italic',
        url: `${fontAppUrl}/Kanit-ExtraLightItalic.woff`,
      },
      {
        name: 'Light Italic',
        url: `${fontAppUrl}/Kanit-LightItalic.woff`,
      },
      {
        name: 'Italic',
        url: `${fontAppUrl}/Kanit-Italic.woff`,
      },
      {
        name: 'Medium Italic',
        url: `${fontAppUrl}/Kanit-MediumItalic.woff`,
      },
      {
        name: 'Semi Bold Italic',
        url: `${fontAppUrl}/Kanit-SemiBoldItalic.woff`,
      },
      {
        name: 'Bold Italic',
        url: `${fontAppUrl}/Kanit-BoldItalic.woff`,
      },
      {
        name: 'Extra Bold Italic',
        url: `${fontAppUrl}/Kanit-ExtraBoldItalic.woff`,
      },
      {
        name: 'Black Italic',
        url: `${fontAppUrl}/Kanit-BlackItalic.woff`,
      },
    ],
  },
  {
    id: 'lobster',
    name: 'Lobster',
    default: 'Regular',
    fonts: [
      {
        name: 'Regular',
        url: `${fontAppUrl}/Lobster-Regular.woff`,
      },
    ],
  },
  // TODO: This should only show for accounts in the Oracle domain.
  // {
  //   name: 'Oracle Sans',
  //   fonts: [
  //     {
  //       name: 'Light',
  //       url: `${fontAppUrl}/oracle/OracleSans_Lt.woff`,
  //     },
  //     {
  //       name: 'Bold',
  //       url: `${fontAppUrl}/oracle/OracleSans_Bd.woff`,
  //     },
  //   ],
  // },
  {
    id: 'oswald',
    name: 'Oswald',
    default: 'Regular',
    fonts: [
      {
        name: 'Extra Light',
        url: `${fontAppUrl}/Oswald-ExtraLight.woff`,
      },
      {
        name: 'Light',
        url: `${fontAppUrl}/Oswald-Light.woff`,
      },
      {
        name: 'Regular',
        url: `${fontAppUrl}/Oswald-Regular.woff`,
      },
      {
        name: 'Medium',
        url: `${fontAppUrl}/Oswald-Medium.woff`,
      },
      {
        name: 'Semi Bold',
        url: `${fontAppUrl}/Oswald-SemiBold.woff`,
      },
      {
        name: 'Bold',
        url: `${fontAppUrl}/Oswald-Bold.woff`,
      },
    ],
  },
  {
    id: 'pacifico',
    name: 'Pacifico',
    default: 'Regular',
    fonts: [
      {
        name: 'Regular',
        url: `${fontAppUrl}/Pacifico-Regular.woff`,
      },
    ],
  },
  {
    id: 'permanent-marker',
    name: 'Permanent Marker',
    default: 'Regular',
    fonts: [
      {
        name: 'Regular',
        url: `${fontAppUrl}/PermanentMarker-Regular.woff`,
      },
    ],
  },
  {
    id: 'playfair-display',
    name: 'Playfair Display',
    default: 'Regular',
    fonts: [
      {
        name: 'Regular',
        url: `${fontAppUrl}/PlayfairDisplay-Regular.woff`,
      },
      {
        name: 'Medium',
        url: `${fontAppUrl}/PlayfairDisplay-Medium.woff`,
      },
      {
        name: 'Semi Bold',
        url: `${fontAppUrl}/PlayfairDisplay-SemiBold.woff`,
      },
      {
        name: 'Bold',
        url: `${fontAppUrl}/PlayfairDisplay-Bold.woff`,
      },
      {
        name: 'Extra Bold',
        url: `${fontAppUrl}/PlayfairDisplay-ExtraBold.woff`,
      },
      {
        name: 'Black',
        url: `${fontAppUrl}/PlayfairDisplay-Black.woff`,
      },
      {
        name: 'Italic',
        url: `${fontAppUrl}/PlayfairDisplay-Italic.woff`,
      },
      {
        name: 'Medium Italic',
        url: `${fontAppUrl}/PlayfairDisplay-MediumItalic.woff`,
      },
      {
        name: 'Semi Bold Italic',
        url: `${fontAppUrl}/PlayfairDisplay-SemiBoldItalic.woff`,
      },
      {
        name: 'Bold Italic',
        url: `${fontAppUrl}/PlayfairDisplay-BoldItalic.woff`,
      },
      {
        name: 'Extra Bold Italic',
        url: `${fontAppUrl}/PlayfairDisplay-ExtraBoldItalic.woff`,
      },
      {
        name: 'Black Italic',
        url: `${fontAppUrl}/PlayfairDisplay-BlackItalic.woff`,
      },
    ],
  },
  {
    id: 'poppins',
    name: 'Poppins',
    default: 'Regular',
    fonts: [
      {
        name: 'Thin',
        url: `${fontAppUrl}/Poppins-Thin.woff`,
      },
      {
        name: 'Extra Light',
        url: `${fontAppUrl}/Poppins-ExtraLight.woff`,
      },
      {
        name: 'Light',
        url: `${fontAppUrl}/Poppins-Light.woff`,
      },
      {
        name: 'Regular',
        url: `${fontAppUrl}/Poppins-Regular.woff`,
      },
      {
        name: 'Medium',
        url: `${fontAppUrl}/Poppins-Medium.woff`,
      },
      {
        name: 'Semi Bold',
        url: `${fontAppUrl}/Poppins-SemiBold.woff`,
      },
      {
        name: 'Bold',
        url: `${fontAppUrl}/Poppins-Bold.woff`,
      },
      {
        name: 'Extra Bold',
        url: `${fontAppUrl}/Poppins-ExtraBold.woff`,
      },
      {
        name: 'Black',
        url: `${fontAppUrl}/Poppins-Black.woff`,
      },
      {
        name: 'Thin Italic',
        url: `${fontAppUrl}/Poppins-ThinItalic.woff`,
      },
      {
        name: 'Extra Light Italic',
        url: `${fontAppUrl}/Poppins-ExtraLightItalic.woff`,
      },
      {
        name: 'Light Italic',
        url: `${fontAppUrl}/Poppins-LightItalic.woff`,
      },
      {
        name: 'Italic',
        url: `${fontAppUrl}/Poppins-Italic.woff`,
      },
      {
        name: 'Medium Italic',
        url: `${fontAppUrl}/Poppins-MediumItalic.woff`,
      },
      {
        name: 'Semi Bold Italic',
        url: `${fontAppUrl}/Poppins-SemiBoldItalic.woff`,
      },
      {
        name: 'Bold Italic',
        url: `${fontAppUrl}/Poppins-BoldItalic.woff`,
      },
      {
        name: 'Extra Bold Italic',
        url: `${fontAppUrl}/Poppins-ExtraBoldItalic.woff`,
      },
      {
        name: 'Black Italic',
        url: `${fontAppUrl}/Poppins-BlackItalic.woff`,
      },
    ],
  },
  {
    id: 'raleway',
    name: 'Raleway',
    default: 'Regular',
    fonts: [
      {
        name: 'Thin',
        url: `${fontAppUrl}/Raleway-Thin.woff`,
      },
      {
        name: 'Extra Light',
        url: `${fontAppUrl}/Raleway-ExtraLight.woff`,
      },
      {
        name: 'Light',
        url: `${fontAppUrl}/Raleway-Light.woff`,
      },
      {
        name: 'Regular',
        url: `${fontAppUrl}/Raleway-Regular.woff`,
      },
      {
        name: 'Medium',
        url: `${fontAppUrl}/Raleway-Medium.woff`,
      },
      {
        name: 'Semi Bold',
        url: `${fontAppUrl}/Raleway-SemiBold.woff`,
      },
      {
        name: 'Bold',
        url: `${fontAppUrl}/Raleway-Bold.woff`,
      },
      {
        name: 'Extra Bold',
        url: `${fontAppUrl}/Raleway-ExtraBold.woff`,
      },
      {
        name: 'Black',
        url: `${fontAppUrl}/Raleway-Black.woff`,
      },
      {
        name: 'Thin Italic',
        url: `${fontAppUrl}/Raleway-ThinItalic.woff`,
      },
      {
        name: 'Extra Light Italic',
        url: `${fontAppUrl}/Raleway-ExtraLightItalic.woff`,
      },
      {
        name: 'Light Italic',
        url: `${fontAppUrl}/Raleway-LightItalic.woff`,
      },
      {
        name: 'Italic',
        url: `${fontAppUrl}/Raleway-Italic.woff`,
      },
      {
        name: 'Medium Italic',
        url: `${fontAppUrl}/Raleway-MediumItalic.woff`,
      },
      {
        name: 'Semi Bold Italic',
        url: `${fontAppUrl}/Raleway-SemiBoldItalic.woff`,
      },
      {
        name: 'Bold Italic',
        url: `${fontAppUrl}/Raleway-BoldItalic.woff`,
      },
      {
        name: 'Extra Bold Italic',
        url: `${fontAppUrl}/Raleway-ExtraBoldItalic.woff`,
      },
      {
        name: 'Black Italic',
        url: `${fontAppUrl}/Raleway-BlackItalic.woff`,
      },
    ],
  },
  {
    id: 'righteous',
    name: 'Righteous',
    default: 'Regular',
    fonts: [
      {
        name: 'Regular',
        url: `${fontAppUrl}/Righteous-Regular.woff`,
      },
    ],
  },
  {
    id: 'roboto',
    name: 'Roboto',
    default: 'Regular',
    fonts: [
      {
        name: 'Thin',
        url: `${fontAppUrl}/Roboto-Thin.woff`,
      },
      {
        name: 'Light',
        url: `${fontAppUrl}/Roboto-Light.woff`,
      },
      {
        name: 'Regular',
        url: `${fontAppUrl}/Roboto-Regular.woff`,
      },
      {
        name: 'Medium',
        url: `${fontAppUrl}/Roboto-Medium.woff`,
      },
      {
        name: 'Bold',
        url: `${fontAppUrl}/Roboto-Bold.woff`,
      },
      {
        name: 'Black',
        url: `${fontAppUrl}/Roboto-Black.woff`,
      },
      {
        name: 'Thin Italic',
        url: `${fontAppUrl}/Roboto-ThinItalic.woff`,
      },
      {
        name: 'Light Italic',
        url: `${fontAppUrl}/Roboto-LightItalic.woff`,
      },
      {
        name: 'Medium Italic',
        url: `${fontAppUrl}/Roboto-MediumItalic.woff`,
      },
      {
        name: 'Bold Italic',
        url: `${fontAppUrl}/Roboto-BoldItalic.woff`,
      },
      {
        name: 'Black Italic',
        url: `${fontAppUrl}/Roboto-BlackItalic.woff`,
      },
    ],
  },
  {
    id: 'shadows-into-light-two',
    name: 'Shadows Into Light Two',
    default: 'Regular',
    fonts: [
      {
        name: 'Regular',
        url: `${fontAppUrl}/ShadowsIntoLightTwo-Regular.woff`,
      },
    ],
  },
];

export const getFontFamilyForUrl = (
  fontFamilies: FontFamily[],
  fontUrl: string,
): FontFamily | null => {
  for (const fontFamily of fontFamilies) {
    for (const font of fontFamily.fonts) {
      if (font.url === fontUrl) {
        return fontFamily;
      }
    }
  }
  return null;
};

export const getFontForUrl = (
  fontFamilies: FontFamily[],
  fontUrl: string,
): Font | null => {
  for (const fontFamily of fontFamilies) {
    for (const font of fontFamily.fonts) {
      if (font.url === fontUrl) {
        return font;
      }
    }
  }
  return null;
};

export const getFontUrl = (fontFamily: FontFamily, fontName: string) => {
  const defaultFont = fontFamily.fonts.find((font) => font.name === fontName);

  return defaultFont?.url || '';
};

export const getDefaultFontUrl = (fontFamily: FontFamily) => {
  return getFontUrl(fontFamily, fontFamily.default);
};

export const injectFontFaces = (fontFamilies: FontFamily[]) => {
  let styleContents = '';

  fontFamilies.forEach((fontFamily) => {
    styleContents += `
@font-face {
  font-family: ${fontFamily.id};
  src: url(${getDefaultFontUrl(fontFamily)}) format('woff');
  font-display: fallback;
}`;
  });

  const style = document.createElement('style');
  style.setAttribute('data-font-families', '');
  style.textContent = styleContents;

  document.head.appendChild(style);
};
